/**
 * @sunflowerlab
 * @author Ashish Kumar
 */

import { HttpErrorResponse } from '@angular/common/http';
import { AppConstants } from './app.constant';

export class ErrorMessages {
  public static readonly errorMessage: string = 'Something went wrong, please try again later.';
  public static readonly serverNotAvailable: string = 'Server is not available at the moment. Please try after sometime.';
  public static readonly INVALID_LOGIN: string = 'The login detail is incorrect.';
  public static readonly csvParserError = 'Errors found in rows. Please correct data and try re-importing.';
  public static readonly notPermitted: string = 'You do not have permission to perform this action.';
  public static readonly importRowsRefused: string = 'These rows were not saved:';
}

export class PermissionDenial {
  public static readonly SERVER_MESSAGE = 'Sorry, your role does not permit this action';

  public static isTenantRoleDenial(errorCode: number, message: string, method: string, url: string): boolean {
    if (errorCode !== 403) {
      return false;
    }
    if ((message || '').toLowerCase().includes('does not permit this action')) {
      return true;
    }
    return !PermissionDenial.isPositionWrite(method, url);
  }

  public static isPositionWrite(method: string, url: string): boolean {
    const verb = (method || '').toUpperCase();
    if (verb !== 'POST' && verb !== 'PUT') {
      return false;
    }
    const path = (url || '').split('?')[0].replace(/\/+$/, '');
    return /\/positions(\/\d+)?$/.test(path);
  }
}

/**
 * The API reports business-rule refusals as a guard key joined to its own text,
 * e.g. 'effective_end_date_exists: Unable to update position'. Those keys are
 * internal names and read as noise in a toast, so translate the ones we recognise.
 * Anything unmapped falls through to the server's text unchanged, so a new guard is
 * never swallowed - it just shows up raw until someone maps it here.
 */
export class ServerErrorMessages {
  private static readonly SEPARATOR = ': ';

  private static readonly BY_KEY: Record<string, string> = {
    effective_end_date_exists: 'This record already has an effective end date recorded against it and can no longer be edited. Please contact your administrator.'
  };

  public static translate(raw: string): string {
    const at = raw.indexOf(ServerErrorMessages.SEPARATOR);
    if (at === -1) {
      return raw;
    }
    return ServerErrorMessages.BY_KEY[raw.slice(0, at)] || raw;
  }

  public static refusal(error: HttpErrorResponse): string | null {
    const errors = error?.error?.errors;
    return error?.status === AppConstants.unprocessableEntityStatus && errors ? ServerErrorMessages.translate(errors.toString()) : null;
  }
}
